<div class="console-container">
  <div>The requested record has been added to the queue.</div>
  <button (click)="close()">OK</button>
</div>
